<template>
    <div class="home-root">
        <!--        <div class="title-image">-->
        <!--            <span class="title" data-text="新疆">-->
        <!--                新疆-->
        <!--            </span>-->
        <!--            <img :src="list[0].showImage"/>-->
        <!--        </div>-->
        <div class="title">
            <h1>新疆</h1>
            <h4>这里是新疆之旅所有全景照片</h4>
        </div>
        <div class="list">
            <div class="item" v-for="(item,index) in  list">
                <span>{{ item.name }}</span>
                <MyImage :info="item" @open="openWorld"></MyImage>
            </div>
        </div>
    </div>
</template>
<script>
import MyImage from "@/components/MyImage.vue";

export default {
    components: {MyImage},
    data() {
        return {
            list: [{
                name: '孟克特古道',
                position:'xjwwezzq',
                imageName:'DJI_20240627193735_0095_D.jpg',
            }, {
                name: '赛里木湖',
                position:'xjwwezzq',
                imageName:'DJI_20240623184653_0135_D.jpg',
            }, {
                name: '315省道-别勒布拉克附近',
                position:'xjwwezzq',
                imageName:'DJI_20240627220916_0133_D.jpg',
            }, {
                name: '独库公路',
                position:'xjwwezzq',
                imageName:'DJI_20240628124446_0140_D.jpg',
            }, {
                name: 'Y209乡道某处',
                position:'xjwwezzq',
                imageName:'DJI_20240622180131_0008_D.jpg',
            }, {
                name: '独库公路',
                position:'xjwwezzq',
                imageName:'DJI_20240628125955_0147_D.jpg',
            }, {
                name: '独库公路-乔尔玛附近',
                position:'xjwwezzq',
                imageName:'DJI_20240628133242_0166_D.jpg',
            }, {
                name: '独库公路-哈希勒根隧道附近',
                position:'xjwwezzq',
                imageName:'DJI_20240628140513_0178_D.jpg',
            }, {
                name: '独库公路-蓝心湖',
                position:'xjwwezzq',
                imageName:'DJI_20240628143726_0198_D.jpg',
            }, {
                name: '独库公路',
                position:'xjwwezzq',
                imageName:'DJI_20240628144804_0200_D.jpg',
            }, {
                name: '恰西国家森林公园',
                position:'xjwwezzq',
                imageName:'DJI_20240626165654_0022_D.jpg',
            }]
        }
    },
    methods: {
        openWorld(realImage,name) {
            let obj = {
                name:name,
                image:realImage
            }
            localStorage.setItem('worldPath', JSON.stringify(obj))
            this.$router.push('/panoramaHome')
        }
    }
}

</script>
<style lang="less">
.title {
    width: 80%;
    margin: 8vh auto 5vh auto;
}

/*当页面大于 1200px 时，大屏幕，主要是 PC 端*/
@media (min-width: 1200px) {
    .home-root {
        width: 100%;
        height: 100vh;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 0px; /* 修改宽度 */
        }


        .title-image {
            width: 100%;
            height: 60vh;
            overflow: hidden; /* 隐藏超出容器部分的图片 */
            display: flex;
            position: relative;

            .title {
                margin: auto;
                font-size: 256px;
                font-weight: 500;
                position: relative;
                display: flex;
                user-select: none;
                white-space: nowrap;
                color: transparent;
                background-color: rgb(252, 252, 252);
                background-clip: text;

            }

            img {
                position: absolute;
                z-index: -1;
                width: 100%;
                height: 100%;
                object-fit: cover;
                transform: scale(2);
            }

        }

        .list {
            width: 80%;
            margin: 5vh auto 5vh auto;
            height: auto;
            display: flex;
            align-content: center;
            justify-content: left;
            flex-wrap: wrap;

            .item {
                cursor: pointer;
                box-shadow: 0 0 6px 2px #999;
                margin: 0 5px 10px 5px;
                width: calc((100% - 60px) / 3);
                height: 30vh;
                overflow: hidden; /* 隐藏超出容器部分的图片 */

                position: relative;

                &:hover {
                    span {
                        opacity: 1 !important;
                    }
                }

                span {
                    pointer-events: none;
                    color: #FFF;
                    z-index: 2;
                    width: 100%;
                    text-align: center;
                    bottom: 0;
                    position: absolute;
                    opacity: 0;
                    background: rgba(255, 255, 255, 0.4);
                    backdrop-filter: blur(7.5px);
                    -webkit-backdrop-filter: blur(7.5px);

                }

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

            }
        }
    }
}

/*在 768 和 991 像素之间的屏幕里，小屏幕，主要是 PAD*/
@media (min-width: 768px) and (max-width: 1199px) {
    .home-root {
        width: 100%;
        height: 100vh;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 0px; /* 修改宽度 */
        }

        .title-image {
            width: 100%;
            height: 30vh;
            overflow: hidden; /* 隐藏超出容器部分的图片 */
            display: flex;
            position: relative;

            .title {
                margin: auto;
                font-size: 64px;
                font-weight: 500;
                position: relative;
                display: flex;
                user-select: none;
                white-space: nowrap;
                color: transparent;
                background-color: rgb(252, 252, 252);
                background-clip: text;

            }

            img {
                position: absolute;
                z-index: -1;
                width: 100%;
                height: 100%;
                object-fit: cover;
                transform: scale(2);
            }

        }

        .list {
            width: 100%;
            height: auto;
            display: flex;
            align-content: center;
            justify-content: left;
            flex-wrap: wrap;

            .item {
                span {
                    display: none;
                }

                cursor: pointer;
                box-shadow: 0px 0px 6px 2px #999;
                width: 100%;
                height: 33vh;
                overflow: hidden; /* 隐藏超出容器部分的图片 */

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

            }
        }
    }
}


/*在小于 480 像素的屏幕，微小屏幕，更低分辨率的手机*/
@media (max-width: 768px) {
    .home-root {
        width: 100%;
        height: 100vh;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 0px; /* 修改宽度 */
        }

        .title-image {
            width: 100%;
            height: 30vh;
            overflow: hidden; /* 隐藏超出容器部分的图片 */
            display: flex;
            position: relative;

            .title {
                margin: auto;
                font-size: 64px;
                font-weight: 500;
                position: relative;
                display: flex;
                user-select: none;
                white-space: nowrap;
                color: transparent;
                background-color: rgb(252, 252, 252);
                background-clip: text;

            }

            img {
                position: absolute;
                z-index: -1;
                width: 100%;
                height: 100%;
                object-fit: cover;
                transform: scale(2);
            }

        }

        .list {
            width: 100%;
            display: flex;
            align-content: center;
            justify-content: left;
            flex-wrap: wrap;
            //margin-bottom: 5vh;

            .item {
                cursor: pointer;
                box-shadow: 0px 0px 6px 2px #999;
                width: 100%;
                height: 30vh;
                overflow: hidden; /* 隐藏超出容器部分的图片 */
                span {
                    display: none;
                }
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transform: scale(1.5);
                }

            }
        }
    }
}
</style>
